// extracted by mini-css-extract-plugin
export var blueBanner = "about-module--blueBanner--u6EoA";
export var contactUs = "about-module--contactUs--PhdHP";
export var container = "about-module--container--GpJlX";
export var getTouch = "about-module--getTouch--2QjJl";
export var header = "about-module--header--hIUMa";
export var main = "about-module--main--gAuNC";
export var mainRaised = "about-module--mainRaised--dASrt";
export var mobileFlex = "about-module--mobileFlex--xSrsZ";
export var mobileSpace = "about-module--mobileSpace--vchYS";
export var ourMission = "about-module--ourMission--O1FwF";
export var paddingMain = "about-module--paddingMain--kDp1q";
export var space150 = "about-module--space150--40gIT";
export var space45 = "about-module--space45--boZEW";
export var space90 = "about-module--space90--+GkaH";
export var statement = "about-module--statement---hFvo";